import React, { FC } from "react";
import { SimpleLink } from "../../types/link";
import { SystemIcon } from "./icons/system";

export type ShortcutProps = {
  children?: string;
  link: SimpleLink;
};

export const Shortcut: FC<ShortcutProps> = ({ link, children }) => (
  <a
    href={link.url}
    title={link.title}
    className="flex justify-between items-center basis-full tablet:basis-2/4 desktop:basis-1/4 grow shrink-0 p-md bg-theme3-200 text-medium font-300 text-secondary-500 desktop:hover:bg-theme3-600 transition-colors ease-in-out duration-200"
  >
    {children}
    <SystemIcon
      name="ArrowRight"
      className="fill-current w-[1rem] h-[1rem] aspect-square"
    />
  </a>
);
